import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { AttractionForm } from '../forms'
import { Dashboard } from '../layouts'
import axios from '../plugins/axios'

const styles = theme => ({
    //
})

class AttractionUpdate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: 'Attractions',
            key: shortid.generate(),
            name: '',
            image: '',
            description: '',
        }
    }

    componentWillMount = () => {
        this.fetchData()
    }

    fetchData = async () => {
        const { match } = this.props
        const { id } = match.params

        try {
            const { data } = await axios.get(`/attractions/${id}`, { progress: true})

            this.setState({
                key: shortid.generate(),
                name: data.name,
                image: data.image,
                description: data.description,
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            title,
            key,
            name,
            image,
            description
        } = this.state
        const { match } = this.props
        const { id } = match.params
        return (
            <Dashboard title={title}>
                <AttractionForm
                    key={key}
                    path={`attractions/${id}`}
                    method="put"
                    name={name}
                    image={image}
                    description={description}
                    message="Амжилттай шинэчлэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(AttractionUpdate)
